module.exports = __webpack_public_path__ + "static/img/knowledge_point.7db5da78.png";